var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsBlender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 37.366,
    viewBox: "0 0 46 37.366",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_blender",
    transform: "translate(-546 -777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_678",
    "data-name": "Path 678",
    d: "M5259.856-7352.342a10.581,10.581,0,0,1,3.841-7.492,12.79,12.79,0,0,1,8.264-2.955,12.794,12.794,0,0,1,8.262,2.955,10.593,10.593,0,0,1,3.841,7.489,10.4,10.4,0,0,1-3.234,8.042,12.66,12.66,0,0,1-8.869,3.5,12.67,12.67,0,0,1-8.874-3.5A10.387,10.387,0,0,1,5259.856-7352.342Z",
    transform: "translate(-4695.761 8150.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_679",
    "data-name": "Path 679",
    d: "M2698.868-3772.534a5.431,5.431,0,0,1,1.971-3.844,6.561,6.561,0,0,1,4.24-1.516,6.563,6.563,0,0,1,4.239,1.516,5.436,5.436,0,0,1,1.971,3.843,5.337,5.337,0,0,1-1.659,4.126,6.5,6.5,0,0,1-4.551,1.8,6.5,6.5,0,0,1-4.553-1.8A5.33,5.33,0,0,1,2698.868-3772.534Z",
    transform: "translate(-2128.888 4570.537)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_680",
    "data-name": "Path 680",
    d: "M2384.963-3967.8a11.344,11.344,0,0,0,.489,2.678,14.129,14.129,0,0,0,3.052,5.285,15.769,15.769,0,0,0,5.342,3.836,17.165,17.165,0,0,0,7.014,1.457,17.181,17.181,0,0,0,7.01-1.481,15.88,15.88,0,0,0,5.338-3.851,14.247,14.247,0,0,0,3.052-5.295,13.38,13.38,0,0,0,.573-2.956,13.463,13.463,0,0,0-.095-2.936,13.64,13.64,0,0,0-1.946-5.326,14.859,14.859,0,0,0-3.551-3.915l0,0-14.37-11.033c-.013-.01-.024-.02-.037-.029a3.194,3.194,0,0,0-3.565,0,1.619,1.619,0,0,0-.235,2.712l0,0,5.993,4.874-18.268.02h-.024a3.33,3.33,0,0,0-3.249,2.244c-.3,1.275.73,2.333,2.3,2.339l0,.006,9.259-.018-16.522,12.682c-.021.015-.044.031-.063.047-1.559,1.193-2.062,3.178-1.081,4.434,1,1.277,3.115,1.28,4.69.007l9.017-7.38a14.12,14.12,0,0,0-.121,1.594Zm23.171,3.336a10.152,10.152,0,0,1-7.274,2.972,10.105,10.105,0,0,1-7.278-2.948,8.652,8.652,0,0,1-1.986-3.109,8.074,8.074,0,0,1-.456-3.474,8.2,8.2,0,0,1,1-3.271,9.014,9.014,0,0,1,2.21-2.628,10.3,10.3,0,0,1,6.51-2.272,10.281,10.281,0,0,1,6.513,2.253,8.978,8.978,0,0,1,2.208,2.62,8.206,8.206,0,0,1,1,3.269,8.1,8.1,0,0,1-.458,3.472A8.692,8.692,0,0,1,2408.135-3964.463Z",
    transform: "translate(-1824.874 4768.909)",
    fill: "#5637fa"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsBlender);
export default __webpack_public_path__ + "static/media/skills_blender.0656976369b1f8f380e56a010006b98a.svg";
export { ForwardRef as ReactComponent };